export default {
  tabListContent: {
    base: {
      borderBottomColor: 'grey-30'
    }
  },
  tab: {
    base: {
      fontWeight: 'xxbold',
      lineHeight: ['24px', '24px', 'base'],
      color: 'grey-50',
      hover: {
        color: 'black'
      },
      focus: {
        color: 'black',
        backgroundColor: 'primary-yellow-100'
      }
    },
    variants: {
      active: {
        borderBottomColor: 'primary',
        color: 'black'
      }
    }
  }
};